import { Button, Dialog, Toolbar, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ReassignDialog = styled(Dialog)(({ theme }) => ({
  // When rendered full-screen (mobile create-tasks flow), let the inner
  // Container fill the available width instead of being constrained to 80%.
  '& .MuiDialog-paperFullScreen .ReassignModal-Container': {
    width: '100%',
    maxWidth: '100%',
    // Keep the horizontal padding inside the 100% width so the content (and
    // its full-width form fields) fits within the full-screen paper instead of
    // overflowing past the right edge on mobile.
    boxSizing: 'border-box',
    padding: theme.spacing(2),
  },
}));

export const ReassignToolbar = styled(Toolbar)({
  height: 70,
});

export const BarTitle = styled('div')(({ theme }) => ({
  flex: 1,
  boxSizing: 'border-box',
  paddingRight: theme.spacing(5),
}));

export const Title = styled(Typography)({
  margin: 0,
  padding: 0,
  lineHeight: 1.2,
  fontWeight: 'bold',
  textAlign: 'center',
});

export const Container = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(4),
  width: '80%',
  maxWidth: 1000,
  margin: '0 auto',
}));

export const ButtonContainer = styled('div')(({ theme }) => ({
  paddingTop: theme.spacing(2),
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: theme.spacing(1),
}));

export const ReassignButton = styled(Button)(({ theme }) => ({
  color: theme.palette.common.white,
  marginRight: theme.spacing(1),
  backgroundColor: theme.palette.secondary.dark,
}));
